module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "copyright-page",
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "iv",
      "id": "piv",
      "role": "doc-pagebreak"
    }
  }), _c('i', [_vm._v("A Union Like Ours")]), _vm._v(" has been supported by the Regional Books Fund, established by donors in 2019 to support the University of Massachusetts Press’s Bright Leaf imprint.")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Bright Leaf, an imprint of the University of Massachusetts Press, publishes accessible and entertaining books about New England. Highlighting the history, culture, diversity, and environment of the region, Bright Leaf offers readers the tools and inspiration to explore its landmarks and traditions, famous personalities, and distinctive flora and fauna.")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Copyright © 2022 by University of Massachusetts Press")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("ISBN 9781613769126 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Cover design by Sally Nichols")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Cover art: photographer unknown, F. O. “Matty” Matthiessen, and Russell Cheney, Normandy, summer "), _c('i', [_vm._v("1925.")]), _vm._v(" F. O. Matthiessen Papers/Beinecke 10560792. Wikimedia CC 1.0.")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Names: Bane, Scott Leslie, 1967– author.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Title: A union like ours : the love story of F. O. Matthiessen and Russell")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("   Cheney / Scott Bane.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Description: Amherst : Bright Leaf, an imprint of University of")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("   Massachusetts Press, 2022. | Includes bibliographical references and")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("   index.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Identifiers: LCCN 2021054624 (print) | LCCN 2021054625 (ebook) | ISBN")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("   9781625346377 (paperback) | ISBN 9781625346384 (hardcover) | ISBN")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("   9781613769119 (ebook) | ISBN 9781613769126 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Subjects: LCSH: Matthiessen, F. O. (Francis Otto), 1902–1950. | Cheney,")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("   Russell, 1881–1945. | Critics—United States—Biography. |")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("   Scholars—United States—Biography. | Painters—United")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("   States—Biography. | Gay men—United States—History—20th century. |")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("   Homosexuality and literature—United States—History—20th century. |")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("   United States—Intellectual life—20th century.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Classification: LCC PS29.M35 B36 2022  (print) | LCC PS29.M35  (ebook) |")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("   DDC 810.9 [B] —dc23/eng/20220204")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("LC record available at https://lccn.loc.gov/2021054624")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("LC ebook record available at https://lccn.loc.gov/2021054625")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("British Library Cataloguing-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("A catalog record for this book is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Portions of the manuscript were previously published as “F. O. Matthiessen and Russell Cheney: A Focus on New England and America,” "), _c('i', [_vm._v("New England Journal of History")]), _vm._v("; “In the Footsteps of F. O. Matthiessen,” "), _c('i', [_vm._v("Gay & Lesbian Review")]), _vm._v(" (November–December 2018); and “Russell Cheney: An Artist in His Own Right,” "), _c('i', [_vm._v("Gay & Lesbian Review")]), _vm._v(" (July–August 2019). Reprinted with permission. Portions of the epilogue were previously published as “In Sickness and in Health,” in "), _c('i', [_vm._v("Memoir Magazine")]), _vm._v(" (November 2020), and “A Union Like Ours,” in "), _c('i', [_vm._v("Hippocampus Magazine")]), _vm._v(" (March/April 2021).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05b3dcfa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uma_Bane0005.vue
// module id = 69
// module chunks = 0